import type { ReactNode } from 'react'

import { FormattedNumber } from 'react-intl'

import { Placeholder } from '@subaio/components'

import { Caption } from './Caption'
import { Container } from './Container'

type Props = {
	amount: number
	currency: string
	userProvidedAmount: number | null
	caption?: ReactNode
	type?: 'neutral' | 'positive' | 'negative'
	isLoading?: boolean
	placeholderWidth?: string
}

export const Amount = ({
	amount,
	currency,
	userProvidedAmount,
	type = 'neutral',
	isLoading = false,
	placeholderWidth,
	caption,
}: Props) => {
	if (userProvidedAmount !== null) {
		return (
			<Container type={type}>
				<Placeholder isLoadingManual={isLoading} width={placeholderWidth}>
					<FormattedNumber value={userProvidedAmount} currency={currency} format='integer-currency' />
				</Placeholder>
				<Caption>{caption}</Caption>
			</Container>
		)
	}

	if (amount === 0) return '-'

	return (
		<Container type={type}>
			<Placeholder isLoadingManual={isLoading} width={placeholderWidth}>
				<FormattedNumber value={amount} currency={currency} format='integer-currency' />
			</Placeholder>
			<Caption>{caption}</Caption>
		</Container>
	)
}
